<template>
    <div
        :class="[
                        'c-message_kit__background',
                        'p-message_pane_message__message',
                        'c-message_kit__message',
                        'slack_message',
                        get_message_class(msg),
                        ]"
        v-if="!msg.deleted"
    >
        <div class="c-message_kit__hover">
            <div class="p-message_pane_message__message_label c-message_kit__labels c-message_kit__labels--light">
                <div
                    class="c-message_kit__labels__label c-message_kit__labels--pinned"
                    v-show="is_pinned(msg)"
                >
                    <div class="c-message_kit__labels__icon"><i
                            class="c-icon c-icon--thumb-tack-filled c-icon--inherit"
                            type="thumb-tack-filled"
                            aria-hidden="true"
                        ></i></div><span class="c-message_kit__labels__text">Pinned by you</span>
                </div>
                <div
                    class="c-message_kit__labels__label c-message_kit__labels--starred"
                    v-show="msg.is_starred"
                >
                    <div class="c-message_kit__labels__icon"><i
                            class="c-icon c-icon--bookmark-filled c-icon--inherit"
                            type="bookmark-filled"
                            aria-hidden="true"
                        ></i></div><span class="c-message_kit__labels__text"><button
                            class="c-link--button c-message_kit__labels__link"
                            type="button"
                            @click="$router.push({ name: 'slack.saveditems'})"
                        >Added to your saved items</button></span>
                </div>
                <div class="slack-msg">
                    <div class="slack-msg-actions columns is-gapless">
                        <slack-icon-button
                            icon="add-reaction"
                            v-slot:trigger
                            @click="show_emoji_picker({e:$event, msg, type:'reaction'})"
                        />
                        <slack-icon-button
                            icon="comment-alt"
                            v-if="visibility.reply_in_thread"
                            @click="$emit('show_replies', msg)"
                        />
                        <slack-icon-button
                            :icon="msg.is_starred ? 'bookmark-filled': 'bookmark'"
                            @click="handle_star(msg)"
                        />
                        <o-dropdown
                            position="bottom-left"
                            aria-role="menu"
                        >
                          <template #trigger>
                            <slack-icon-button
                                icon="vertical-ellipsis"
                            />
                          </template>
                            <o-dropdown-item
                                aria-role="menuitem"
                                @click="turnoff_notifications(msg)"
                            >{{ (!msg.notifications_disabled ? "Turn off notifications for replies" : "Get notified about new replies") }}
                            </o-dropdown-item>
                            <hr
                                class="dropdown-divider"
                                aria-role="menuitem"
                            />
                            <o-dropdown-item
                                aria-role="menuitem"
                                @click="handle_pin(msg)"
                            >
                                {{ !is_pinned(msg, channel) ? "Pin to this conversation" : "Up-pin from this conversation" }}
                            </o-dropdown-item>
                            <o-dropdown-item
                                aria-role="menuitem"
                                class="is-danger"
                            >
                                <button
                                    class="
                                            c-button-unstyled
                                            p-message_actions_menu__delete_message
                                            c-menu_item__button
                                            c-menu_item__button--danger
                                        "
                                    role="menuitem"
                                    tabindex="-1"
                                    type="button"
                                >
                                    <div
                                        class="c-menu_item__label"
                                        @click="confirm_delete_message(msg)"
                                    >
                                        Delete message
                                    </div>
                                </button>
                            </o-dropdown-item>
                        </o-dropdown>
                        <div class="column"></div>
                    </div>
                    <div class="slack-msg-user-icon">
                        <img
                            :src="msg.user_info.profile.image_48"
                            alt="Profile"
                        />
                    </div>
                    <div class="slack-msg-content">
                        <span class="slack-msg-user-name">{{
                            msg.user_info.real_name
                        }}</span>
                        <span class="slack-msg-time">{{
                            get_msg_time(msg)
                        }}</span>
                        <br />
                        <div
                            class="slack-msg-text c-message_kit__blocks--rich_text"
                            v-html="get_message(msg)"
                        />
                      <div v-if="get_files()">
                        <a :href="get_files()" class="button is-success" target="_blank">View Image</a>
                      </div>

                        <message-reactions
                            :message="msg"
                            @add_reaction="show_emoji_picker"
                            @react="toggle_reaction"
                        />
                        <slack-message-reply-bar
                            v-if="visibility.reply_bar"
                            :message="msg"
                            @show_replies="$emit('show_replies', msg)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { delete_message, get_message, get_msg_time, is_pinned, list_conversation, list_replies, pin, reactions, star, unpin, unstar } from '../../slack_api'
import MessageReactions from './MessageReactions.vue'
import SlackIconButton from '../SlackIconButton'
import SlackMessageReplyBar from './SlackMessageReplyBar'
export default {
    components: {
        MessageReactions,
        SlackIconButton,
        SlackMessageReplyBar,
    },
    computed: {
        ...mapGetters([
            'slack_is_signed_in',
        ]),
    },
    data() {
        return {
            img: false,
            visibility: {
                reply_bar: false,
                reply_in_thread: false,
            },
        }
    },
    methods: {
        get_files(){
          if (this.msg.files){
            this.img = this.msg.files[0].url_private
          }
          return this.img;
        },
        confirm_delete_message(msg) {
            return this.confirmMessage(
                'Confirm action',
                'Confirm delete message?',
                'Yes'
            ).then(() => {
                delete_message(this.channel, msg.ts).then(({ ok }) => {
                    if (!ok) {
                        this.errorMessage('Error deleting message')
                        return
                    }
                    msg.deleted = true
                    this.$forceUpdate()
                    this.successMessage('Message deleted successfull')
                }, () => this.errorMessage('Error deleting message'))
            }, r => Promise.reject(r))
        },
        get_message,
        get_message_class(msg) {
            const is_msg_pinned = is_pinned(msg, this.channel)
                , is_starred = msg.is_starred
                , labels = 'c-message_kit__background--labels'
                , class_obj = {}
            switch (this.type) {
                case 'message':
                    class_obj['p-message_pane_message__message'] = true
                    break
                case 'thread-root':
                    class_obj['c-message_kit__thread_message--root'] = true
                case 'thread':
                    class_obj['message_kit__thread_message'] = true
                    break
            }
            if (is_msg_pinned || is_starred) {
                class_obj[labels] = true
                if (is_msg_pinned) {
                    class_obj[`${labels}--pinned`] = true
                }
                if (is_starred) {
                    class_obj[`${labels}--starred`] = true
                }
            }
            return class_obj
        },
        get_msg_time,
        handle_pin(msg) {
            if (is_pinned(msg)) {
                this.confirmMessage('Remove pinned item', 'Are you sure you want to remove this pinned item?').then(() => {
                    unpin(msg.ts, this.channel).then(() => {
                        this.update_item(msg)
                    })
                })
            } else {
                pin(msg.ts, this.channel).then(r => {
                    if (r.ok) {
                        this.update_item(msg)
                    } else {
                        this.errorMessage('Message could not be pinned')
                    }
                })
            }
        },
        handle_star(msg) {
            const fn = msg.is_starred ? unstar : star
            fn(msg.ts, this.channel).then(({ ok }) => ok && this.update_item(msg))
        },
        is_pinned,
        show_emoji_picker({ e, msg, type = 'reaction' }) {
            this.$emit('add_reaction', { e, msg, type })
        },
        toggle_reaction(reaction) {
            const { name, reacted } = reaction
            reactions(name, this.msg.ts, this.channel, reacted ? 'remove' : 'add').then(res => {
                if (res.ok) {
                    this.update_item(this.msg).then(() => this.$forceUpdate())
                }
            })
        },
        turnoff_notifications(item) {
            item.notifications_disabled = !item.notifications_disabled
            this.$forceUpdate()
        },
        update_item(msg) {
            const response = response => {
                if (!response.ok || response.messages.length === 0) {
                    return
                }
                const { messages } = response
                this.$emit('updated', messages[0])
            }
            if ('thread' === this.type) {
                return list_replies(this.channel, msg.ts, { inclusive: true, latest: msg.ts, limit: 1 }).then(response)
            }
            return list_conversation(this.channel, { inclusive: true, latest: msg.ts, limit: 1 }).then(response)
        },
    },
    mounted() {
        switch (this.type) {
            case 'message':
                this.visibility.reply_bar = true
                this.visibility.reply_in_thread = true
                break
            case 'thread-root':
            case 'thread':
                break
        }
    },
    props: {
        channel: { type: String, },
        msg: { type: Object, },
        type: {
            default: 'message',
            type: String,
        }
    },
    unmounted() {
    },
}
</script>
<style lang="sass">
.slack_message
  .c-message_kit__labels--pinned, .c-message_kit__labels--starred
    display: none
  &.c-message_kit__background--labels
    .c-message_kit__labels--pinned, .c-message_kit__labels--starred
      display: flex
  .c-message_kit__hover
    position: relative
    &:hover
      background-color: rgb(248, 248, 248)
      .slack-msg
        .slack-msg-actions
          display: flex
    .slack-msg
      display: flex
      line-height: 1.46668
      margin: 8px 20px
      &:hover
        .slack-msg-actions
          display: flex
      .slack-msg-actions
        --saf-0: rgba(29,28,29,0.13)
        background-color: #fff
        border: unset
        border-radius: 0.375em
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08)
        display: none
        padding: 2px
        position: absolute
        right: 17px
        top: -28px
        >.dropdown
          font-size: 15px
          >.dropdown-menu
            >.dropdown-content
              width: 300px
              >a.dropdown-item
                &:hover
                  color: #fff
                  text-decoration: none
                  &:is(.is-danger)
                    background-color: #e01e5a
                  &:not(.is-danger)
                    background-color: #1264a3
                  button
                    color: #fff
      .slack-msg-content
        flex: 1 1 0
        font-weight: 400
        .slack-msg-user-name
          font-weight: 900
        .slack-msg-time
          font-size: 12px
        .slack-msg-text, .c-message_kit__blocks--rich_text
          max-width: none
          margin-bottom: 4px
          word-break: break-word
          white-space: break-spaces
          .slack-mention
            background-color: #1d9bd11a
            border-radius: 3px
            color: #1264a3
            padding: 0 2px 1px 2px
            &.me
              background-color: #f2c74466
      .slack-msg-user-icon
        height: 36px
        margin-right: 8px
        min-width: 36px
        width: 36px
        > img
          border-radius: 4px
</style>